import { Link } from 'react-router-dom';
import { Phone, MapPin, Clock } from 'lucide-react';

export const Footer = () => {
  const serviceAreas = [
    { name: 'Toronto', path: '/toronto-appliance-repair' },
    { name: 'East York', path: '/east-york-appliance-repair' },
    { name: 'North York', path: '/north-york-appliance-repair' },
    { name: 'Vaughan', path: '/vaughan-appliance-repair' },
    { name: 'Richmond Hill', path: '/richmond-hill-appliance-repair' },
    { name: 'King City', path: '/king-city-appliance-repair' },
    { name: 'Woodbridge', path: '/woodbridge-appliance-repair' },
    { name: 'Markham', path: '/markham-appliance-repair' },
  ];

  const services = [
    'Refrigerator Repair',
    'Washer & Dryer Repair',
    'Dishwasher Repair',
    'Stove & Oven Repair'
  ];

  return (
    <footer className="bg-[#1A2B4C] text-white" data-testid="main-footer">
      {/* CTA Section */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="text-2xl md:text-3xl font-bold mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Need Same-Day Repair?
              </h3>
              <p className="text-white/70">Our technicians are ready to help across the GTA.</p>
            </div>
            <a
              href="tel:647-919-6893"
              className="flex items-center gap-3 px-8 py-4 rounded-full font-bold text-lg transition-transform hover:scale-105"
              style={{ background: '#FF6B00', fontFamily: 'Montserrat, sans-serif' }}
              data-testid="footer-cta-button"
            >
              <Phone size={22} />
              <span>Call 647-919-6893</span>
            </a>
          </div>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_infinity-gta-repair/artifacts/382cgbmn_WhatsApp%20Image%202026-03-04%20at%2012.45.59.jpeg" 
                alt="Infinity Appliances Repair Logo"
                className="h-20 w-auto object-contain bg-white rounded-lg p-2"
              />
            </div>
            <p className="text-white/70 mb-6 leading-relaxed">
              Expert appliance repair services across the Greater Toronto Area. Licensed, insured, and ready to help.
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-white/70">
                <MapPin size={18} className="text-[#FF6B00]" />
                <span>Toronto & GTA, Ontario</span>
              </div>
              <div className="flex items-center gap-3 text-white/70">
                <Phone size={18} className="text-[#FF6B00]" />
                <a href="tel:647-919-6893" className="hover:text-white transition-colors" data-testid="footer-phone">
                  647-919-6893
                </a>
              </div>
              <div className="flex items-center gap-3 text-white/70">
                <Clock size={18} className="text-[#FF6B00]" />
                <span>24/7 Emergency Service</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-6" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Our Services
            </h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <Link 
                    to="/" 
                    className="text-white/70 hover:text-[#FF6B00] transition-colors"
                    data-testid={`footer-service-${service.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Service Areas - All Linked */}
          <div>
            <h4 className="text-lg font-bold mb-6" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Service Areas
            </h4>
            <ul className="space-y-3">
              {serviceAreas.map((area) => (
                <li key={area.name}>
                  <Link 
                    to={area.path} 
                    className="text-white/70 hover:text-[#FF6B00] transition-colors"
                    data-testid={`footer-area-${area.name.toLowerCase().replace(' ', '-')}`}
                  >
                    {area.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-white/70 hover:text-[#FF6B00] transition-colors" data-testid="footer-link-home">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/toronto-appliance-repair" className="text-white/70 hover:text-[#FF6B00] transition-colors" data-testid="footer-link-toronto">
                  Toronto Service
                </Link>
              </li>
              <li>
                <Link to="/vaughan-appliance-repair" className="text-white/70 hover:text-[#FF6B00] transition-colors" data-testid="footer-link-vaughan">
                  Vaughan Service
                </Link>
              </li>
              <li>
                <Link to="/richmond-hill-appliance-repair" className="text-white/70 hover:text-[#FF6B00] transition-colors" data-testid="footer-link-richmond">
                  Richmond Hill Service
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-white/70 hover:text-[#FF6B00] transition-colors" data-testid="footer-link-blog">
                  Blog
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-white/50 text-sm">
            <p>&copy; {new Date().getFullYear()} Infinity Appliances Repair. All rights reserved.</p>
            <p>
              Serving Toronto, East York, North York, Vaughan, Richmond Hill, King City, Woodbridge & Markham
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
